import { createContext } from "react";

export enum LocationType {
  Ip = "ip",
  LocationPermissions = "locationPermissions"
}

export interface LocationAllowedResult {
  allowed: boolean;
  locationName: string;
  type?: LocationType;
}

export interface LocationContextType {
  locationAllowed: LocationAllowedResult | undefined;
  isLocationLoading: boolean;
  error: Error | undefined;
  refreshLocation: (force?: boolean) => Promise<LocationAllowedResult | undefined>;
  setLocation: (location: string, type: LocationType) => void;
}

export const LocationContext = createContext<LocationContextType | undefined>(undefined);